import {BaseNames} from 'src/marketConnect/helpers'

/** Remap legacy Primary/Secondary wording in API-sourced display text. */
export const remapLegacyRoleDisplayText = (text: string | null | undefined): string => {
  if (!text) return ''

  return text
    .replace(/\bPrimary\b/g, BaseNames.PRIMARY_Name)
    .replace(/\bprimary\b/g, BaseNames.PRIMARY_Name.toLowerCase())
    .replace(/\bSecondary\b/g, BaseNames.SECONDARY_Name)
    .replace(/\bsecondary\b/g, BaseNames.SECONDARY_Name.toLowerCase())
}
